import * as React from "react";
import CustomDonut from './DataViz/customDonutChart.Component';
import "./resultTiles.css";
import Loader from "react-loader";
import ModalVideo from "react-modal-video";

import { determineAlertLevel, zeroPaddedStr } from '../common/services';

class TraitTile extends React.PureComponent<any, any> {
  public state = {
    vimeoOpen: false,
    vimeoID: null,
  };
  constructor(props) {
    super(props);
  }

  public componentDidMount() {
    // do something
  }
  public openModal = (e) => {
    const { vimeoOpen } = this.state;
    this.setState({ vimeoOpen: !vimeoOpen, vimeoID: e.target.value });
  };
  public closeModal = () => {
    this.setState({ vimeoID: "", vimeoOpen: false });
  };

  public render() {
    if (this.props.results) {
      const vimeoKey =
        this.props.vimeoModel === "parents"
          ? "ParentVimeoModel"
          : this.props.vimeoModel === "students"
            ? "StudentVimeoModel"
            : "TeacherVimeoModel";

      return (
        <div className="trait-container">
          <ModalVideo
            channel="vimeo"
            isOpen={this.state.vimeoOpen}
            onClose={this.closeModal}
            videoId={this.state.vimeoID}
          />
          <div className="trait-speedo">
            <div style={{ width: "190px" }}>
              <CustomDonut
                value={this.props.results.PLOAScore}
                color="#f56f3f"
                text={zeroPaddedStr(Math.round(this.props.results.PLOAScore))}
                alertLevel={this.props.results.RiskLevel}
              />
            </div>
            {/* <p className="trait-speedo-level"> Your Performance Learning Score
            </p> */}
          </div>
          <div className="trait-details">
            <h2 className="trait-header">{this.props.results.TraitTitle}</h2>
            <p className="trait-copy">{this.props.results.TraitCopy}</p>
            {/* <button
              className="watch-video blue-button"
              value={
                this.props.results[vimeoKey] !== null
                  ? this.props.results[vimeoKey].VideoData.id
                  : `${vimeoKey} no Vimeo`
              }
              onClick={this.openModal}
            >
              Watch a video explaining the results
            </button> */}
          </div>
        </div>
      );
    } else {
      return <Loader color="#acff2400" />;
    }
  }
}

export default TraitTile;



// WEBPACK FOOTER //
// ./src/common/traitTile.Component.tsx